import { useEffect, useState } from "react";
import { isSchoolMode, msUntilNextSchoolCheck } from "@/lib/schoolTime";

/**
 * Watches a profile's school-time settings and returns whether the board
 * should currently show its school-time view. Defaults to "home" until the
 * profile loads, mirroring the original inline effect in Board.jsx.
 *
 * Reads:
 *   - profile.school_start, profile.school_end
 *   - profile.school_mode_override ("auto" | "home" | "school")
 *
 * Pure refactor — identical behavior to the inline effect previously in
 * Board.jsx. Keeping this in /lib makes the Board easier to read and
 * lets us unit-test the timer separately later.
 */
export function useSchoolModeAuto(profile) {
  const [schoolOn, setSchoolOn] = useState(false);

  useEffect(() => {
    if (!profile) return undefined;
    const tick = () => setSchoolOn(isSchoolMode(profile));
    tick();
    let timer = setTimeout(function loop() {
      tick();
      timer = setTimeout(loop, msUntilNextSchoolCheck());
    }, msUntilNextSchoolCheck());
    return () => clearTimeout(timer);
  }, [
    profile?.id,
    profile?.school_start,
    profile?.school_end,
    profile?.school_mode_override,
  ]);

  return schoolOn;
}
